import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../Model/Common/common.service';
import { UserMasterService } from '../user-master.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { UserApplicabilityFilterComponent } from '../user-applicability-filter/user-applicability-filter.component';
import { ApprovalMatrixService } from '../Model/ApprovalMatrix/approval-matrix.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { SeparationModuleService } from '../separation-module.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../Util/Session/session.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-separation-policy',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule, FormsModule, NgSelectModule, LoaderComponent],
  templateUrl: './separation-policy.component.html',
  styleUrl: './separation-policy.component.scss'
})
export class SeparationPolicyComponent {

  isDisabled: boolean = false;

  constructor(
    protected tooltip: TooltipService,
    protected common: CommonService,
    private userMasterService: UserMasterService,
    private modalService: NgbModal,
    private approvalMatrix: ApprovalMatrixService,
    private toast: ToastService,
    private separation: SeparationModuleService,
    private route: ActivatedRoute,
    private router: Router,
    private session: SessionService
  ) {
    // this.common.getPageRights();
    this.user = session.GetUserDetails();
    this.route.params.subscribe(params => this.SeparationRuleID = parseInt(params['id']));
  }

  ngOnInit() {
    // this.ComboLoad('UserMasterForUserApplicability');
    // this.ComboLoad('ApplicabilityMaster');
    this.GetApplicability();
  }

  allowBackdateSeparation: boolean = false;
  policybasedon = 'Month';
  user = {} as any;
  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;
  Applicabilitys = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  Regions = [] as any;
  RegionsFilter = [] as any;
  Zone = [] as any;
  ZoneFilter = [] as any;
  IndustrySegment = [] as any;
  IndustrySegmentFilter = [] as any;
  LastWebESSUserApplicabilityMasterID = null;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;
  User: any;
  PolicyName = ''
  SeparationRuleID = 0;
  ProbationNoticePeriod = ''
  ConfirmedNoticePeriod = ''
  lastWorkingDayEditable = false;
  PastLWDLimitDays = '';
  FutureLWDLimitDays = '';
  BackDateSeparationDays = '';
  DefaultRule = false;
  LastWebESSApplicabilityId = null;

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.userMasterService.ComboLoad({
      'SelectType': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'UserMasterForUserApplicability') {
          this.Users = response.Table;
          this.isDisabled = false;
        }
        else if (Combotype == 'ApplicabilityMaster') {
          this.Applicabilitys = response.Table;
          this.isDisabled = false;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }

  SeparationRuleDetail = {
    SelectType: '',
    WebESSUserAccessControlMasterID: 0,
    WebESSUserApplicabilityMasterID: null as any,
    MappedId: null as any,
    UserMasterID: null as any,
    EmpType: 'FRONT'
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null
  }

  ApprovalComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.userMasterService.ComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID
    }).subscribe({
      next: (response) => {
        if (Combotype == 'CompanyMasterForUserApplicability') {
          // this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterID));
          // this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterID));

          this.Companys = response.Table;
          this.CompanysFilter = response.Table;

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterID,
                ApplicabilityData: element.CompanyName,
                WebESSUserApplicabilityMasterID: this.SeparationRuleDetail.WebESSUserApplicabilityMasterID,
                IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'BranchMasterForUserApplicability') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSUserApplicabilityMasterID: this.SeparationRuleDetail.WebESSUserApplicabilityMasterID,
                IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'ClientMasterForUserApplicability') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ClientGroupMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ClientGroupMasterID,
                  ApplicabilityData: element.ClientGroupName,
                  WebESSUserApplicabilityMasterID: this.SeparationRuleDetail.WebESSUserApplicabilityMasterID,
                  IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'SiteMasterForUserApplicability') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteName,
                  WebESSUserApplicabilityMasterID: this.SeparationRuleDetail.WebESSUserApplicabilityMasterID,
                  IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'RegionMasterForUserApplicability') {

          this.Regions = response.Table;
          this.RegionsFilter = response.Table;

          this.Regions.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.RegionMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.RegionMasterID,
                  ApplicabilityData: element.RegionName,
                  WebESSUserApplicabilityMasterID: this.SeparationRuleDetail.WebESSUserApplicabilityMasterID,
                  IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.RegionMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'ZoneMasterForUserApplicability') {

          this.Zone = response.Table;
          this.ZoneFilter = response.Table;

          this.Zone.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ZoneMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ZoneMasterID,
                  ApplicabilityData: element.ZoneName,
                  WebESSUserApplicabilityMasterID: this.SeparationRuleDetail.WebESSUserApplicabilityMasterID,
                  IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.ZoneMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'IndustrySegmentMasterForUserApplicability') {
          this.IndustrySegment = response.Table;
          this.IndustrySegmentFilter = response.Table;

          this.IndustrySegment.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.IndustrySegmentID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.IndustrySegmentID,
                  ApplicabilityData: element.IndustrySegmentName,
                  WebESSUserApplicabilityMasterID: this.SeparationRuleDetail.WebESSUserApplicabilityMasterID,
                  IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.IndustrySegmentID) >= 0 ? true : false : false,
                }
              );
            }
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.SeparationRuleDetail.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  // async ApplicabilityDataFilter(IsFilter = false) {
  //   if (IsFilter || await this.Confirmation(IsFilter)) {
  //     if (!IsFilter) {
  //       this.ApplicabilityDatas = [];
  //       this.ApplicabilityDatasFilter = [];
  //       this.SeparationRuleDetail.MappedId = null;
  //       this.LastWebESSUserApplicabilityMasterID = this.SeparationRuleDetail.WebESSUserApplicabilityMasterID;
  //     } else {
  //       this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
  //       this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
  //     }

  //     this.Filter.BranchID = null;
  //     this.Filter.ClientID = null;
  //     if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 1) {
  //       this.ApprovalComboLoad('CompanyMasterForUserApplicability');
  //     } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 2) {
  //       this.ApprovalComboLoad('BranchMasterForUserApplicability');
  //     }
  //     // else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 3) {
  //     //   this.ApprovalComboLoad('ClientMasterForUserApplicability');
  //     // } 
  //     else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 4) {
  //       this.ApprovalComboLoad('RegionMasterForUserApplicability');
  //     } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 5) {
  //       this.ApprovalComboLoad('ZoneMasterForUserApplicability');
  //     } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 6) {
  //       this.ApprovalComboLoad('IndustrySegmentMasterForUserApplicability');
  //     }
  //     // else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 7) {
  //     //   this.ApprovalComboLoad('SiteMasterForUserApplicability');
  //     // }
  //     else {
  //       if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID != 0) {
  //         this.FilterForm();
  //       }
  //     }
  //   }
  // }

  async ApplicabilityDataFilter(IsFilter = false) {debugger
    // if (this.RegularizationRuleDetail.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.SeparationRuleDetail.MappedId = null;
        this.LastWebESSApplicabilityId = this.SeparationRuleDetail.WebESSUserApplicabilityMasterID;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID != 0) {
          this.FilterForm();
        }
      }
    }
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSUserApplicabilityMasterID != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.SeparationRuleDetail.WebESSUserApplicabilityMasterID = this.LastWebESSUserApplicabilityMasterID;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  FilterForm() {
    const modalRef = this.modalService.open(UserApplicabilityFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 3 ? 'Client' : this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 7 ? 'Site' : '';
    modalRef.componentInstance.WebESSUserApplicabilityMasterID = this.SeparationRuleDetail.WebESSUserApplicabilityMasterID;
    modalRef.componentInstance.EmpType = this.SeparationRuleDetail.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 3 || this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 7) ? true : false,
      ShowClient: (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 7) ? true : false,
    }
    modalRef.result.then(result => {
      console.log(result);
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 1) {
        this.ApprovalComboLoad('CompanyMasterForUserApplicability');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 2) {
        this.ApprovalComboLoad('BranchMasterForUserApplicability');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 3) {
        this.ApprovalComboLoad('ClientMasterForUserApplicability');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 4) {
        this.ApprovalComboLoad('RegionMasterForUserApplicability');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 5) {
        this.ApprovalComboLoad('ZoneMasterForUserApplicability');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 6) {
        this.ApprovalComboLoad('IndustrySegmentMasterForUserApplicability');
      } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 7) {
        this.ApprovalComboLoad('SiteMasterForUserApplicability');
      }
    });
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.SeparationRuleDetail.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (response.Table.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0) >= 0) {
          this.Applicabilitys.push(response.Table.filter((e: any) => e.WebESSApplicabilityMasterID == 0)[0]);
          this.Applicabilitys.splice(this.Applicabilitys.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0), 1);
        }
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.SeparationRuleDetail.WebESSUserApplicabilityMasterID).length == 0) {
          this.SeparationRuleDetail.WebESSUserApplicabilityMasterID = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetApplicabilityAccess() {
    this.ApplicabilityDatas = [];
    this.isDisabled = true;
    this.userMasterService.LoadApplicability({
      SelectType: 1,
      UserMasterID: this.SeparationRuleDetail.UserMasterID,
    }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.SeparationRuleDetail.WebESSUserApplicabilityMasterID = response.Table[0].WebESSUserApplicabilityMasterId;
        }
        if (response.Table1.length > 0) {
          this.SeparationRuleDetail.MappedId = response.Table1.map((obj: any) => obj.MappedId).join(",");
        }

        console.log(this.SeparationRuleDetail.MappedId);

        if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 1) {
          this.ApprovalComboLoad('CompanyMasterForUserApplicability');
        } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 2) {
          this.ApprovalComboLoad('BranchMasterForUserApplicability');
        } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 3) {
          this.ApprovalComboLoad('ClientMasterForUserApplicability');
        } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 4) {
          this.ApprovalComboLoad('RegionMasterForUserApplicability');
        } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 5) {
          this.ApprovalComboLoad('ZoneMasterForUserApplicability');
        } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 6) {
          this.ApprovalComboLoad('IndustrySegmentMasterForUserApplicability');
        } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 7) {
          this.ApprovalComboLoad('SiteMasterForUserApplicability');
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 7) ||
      (id == 0 && (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 3 || this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == 7))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client and site.", type: toastTypeEnum.warning });
    }
  }

  SaveSeparationPolicy() {
    if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID == null) {
      this.toast.show({ message: 'Please select applicability', type: toastTypeEnum.warning });
      return;
    } else if (this.SeparationRuleDetail.WebESSUserApplicabilityMasterID > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: 'Please select sub applicability', type: toastTypeEnum.warning });
      return;
    }
    
    this.SeparationRuleDetail.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSUserApplicabilityMasterID == this.SeparationRuleDetail.WebESSUserApplicabilityMasterID).map((e: any) => e.ApplicabilityDataID).toString()
    this.isDisabled = true;

    this.separation.SeparationRuleInsertUpdate({
      SelectType: this.SeparationRuleID == 0 || this.SeparationRuleID == null ? 'Insert' : 'Update',
      ESS_SeparationRuleId: this.SeparationRuleID,
      SeparationRuleName: this.PolicyName,
      DefaultRule: this.DefaultRule,
      EmpType: this.user.EmpType,
      PolicyBasedOn: this.policybasedon,
      ProbationNoticePeriod: this.ProbationNoticePeriod,
      ConfirmedNoticePeriod: this.ConfirmedNoticePeriod,
      IsEmployeeLWDEditable: this.lastWorkingDayEditable,
      PastLWDLimitDays: this.PastLWDLimitDays,
      FutureLWDLimitDays: this.FutureLWDLimitDays,
      IsBackdateSeparationAllowed: this.allowBackdateSeparation,
      BackdateSeparationAllowedDays: this.BackDateSeparationDays,
      WebESSApplicabilityId: this.SeparationRuleDetail.WebESSUserApplicabilityMasterID,
      MappedId: this.SeparationRuleDetail.MappedId,
      By: this.user.UserId,
    }).subscribe({
      next: (response) => {
        if(response.ErrorCode == "01"){
          this.toast.show({ message: response.ErrorMessage, type: toastTypeEnum.success });
          this.close();
        }else{
          this.toast.show({ message: response.ErrorMessage, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (err) => {
        this.isDisabled = false;
      },
    })
  }

  Validate(form: any) {
    // if (form.valid) {
      this.SaveSeparationPolicy();
    // }
    // else {
    //   form.submitted = true;
    // }
  }

  close() {
    this.router.navigate(['/setting/separationpolicy/']);
  }
}